import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import { EMAIL, TRADES } from "@/lib/data";

const NAV = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

export default function Footer() {
    return (
        <footer className="border-t border-white/10 bg-[#080C14]">
            <div className="container-x py-16 md:py-20">
                <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
                    <div className="md:col-span-5">
                        <Logo />
                        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
                            Multi-discipline technical services — electrical
                            installation, plumbing, heat &amp; air-conditioning,
                            security systems, and appliance &amp; garden equipment
                            repair.
                        </p>
                    </div>

                    <div className="md:col-span-2">
                        <p className="field-label">Company</p>
                        <ul className="space-y-3">
                            {NAV.map((item) => (
                                <li key={item.to}>
                                    <Link
                                        to={item.to}
                                        className="text-sm text-slate-300 transition-colors hover:text-amber-400"
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <p className="field-label">Trades registry</p>
                        <ul className="space-y-3">
                            {TRADES.map((t) => (
                                <li key={t.code}>
                                    <Link
                                        to={`/services#trade-${t.code}`}
                                        className="group flex items-center gap-2 text-sm text-slate-300 transition-colors hover:text-amber-400"
                                    >
                                        <span className="font-mono text-[11px]" style={{ color: t.accent }}>
                                            {t.code}
                                        </span>
                                        <span className="truncate">{t.title}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <p className="field-label">Contact</p>
                        <a
                            data-testid="footer-email-link"
                            href={`mailto:${EMAIL}`}
                            className="group inline-flex items-center gap-2 break-all text-sm text-amber-400 transition-colors hover:text-amber-300"
                        >
                            <Mail size={14} className="shrink-0" />
                            {EMAIL}
                            <ArrowUpRight
                                size={13}
                                className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                            />
                        </a>
                    </div>
                </div>

                <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-7 md:flex-row md:items-center md:justify-between">
                    <p className="font-mono text-[11px] text-slate-500">
                        © {new Date().getFullYear()} Services &amp; Prestations Ltd. All rights reserved.
                    </p>
                    <p className="font-mono text-[11px] tracking-[0.14em] text-slate-600">
                        NACE 43210 · 43220 · 80200 · 95220
                    </p>
                </div>
            </div>
        </footer>
    );
}
